export interface IAttachment {
  id: number;
  name: string;
  contentType: string;
  keyPath: string;
  attrs: {
    key: string;
  };
}

export interface IBlobAttachment extends IAttachment {
  type: 'blob';
  loader: any;
}
